<template>
  <div>
    <nav
      class="d-flex d-lg-none navbar navbar-expand-lg navbar-light bg-white mb-3 px-3 py-0"
      v-if="$route.meta.navigationAvailable"
    >
      <a class="navbar-brand d-flex align-items-center" href="/">
        <img style="width:160px" src="../../assets/iSimulate-Logo.svg" />
      </a>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarText"
        aria-controls="navbarText"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse w-lg-0" id="navbarText">
        <div class="d-lg-none">
          <div class="input-group d-flex align-items-center">
            <input
              type="text"
              class="form-control search-box"
              placeholder="Search"
              aria-label="Search site"
              aria-describedby="basic-addon2"
              v-model="searchTerm"
              v-on:keyup.enter="search"
            />
          </div>

          <ul class="navbar-nav mr-auto"></ul>
          <NavCollapsedButtons />
        </div>
      </div>
    </nav>
    <!-- ^ Collapsed nav ^ -->

    <nav
      class="d-none d-lg-flex navbar navbar-expand-lg navbar-light bg-white mb-3 px-3 py-0"
      style="justify-content: center"
      v-if="$route.meta.navigationAvailable"
    >
      <div class="nav-container">
        <div class="nav-container-left">
          <a class="navbar-brand d-flex align-items-center" href="/">
            <img style="width:160px" src="../../assets/iSimulate-Logo.svg" />
          </a>

          <div class="input-group d-flex align-items-center">
            <input
              type="text"
              class="form-control search-box"
              placeholder="Search"
              aria-label="Search site"
              aria-describedby="basic-addon2"
              v-model="searchTerm"
              v-on:keyup.enter="search"
            />
          </div>
        </div>

        <NavExpandedButtons />
      </div>
    </nav>
    <!-- ^ Expanded nav ^ -->
  </div>
</template>

<script>
import NavCollapsedButtons from "./NavCollapsedButtons";
import NavExpandedButtons from "./NavExpandedButtons";

export default {
  name: "Navbar",
  components: {
    NavCollapsedButtons,
    NavExpandedButtons,
  },
  data: function() {
    return {
      searchTerm: "",
    };
  },
  methods: {
    search() {
      this.$store.commit("setSearchTerm", this.searchTerm.toLowerCase());
      this.$router.push({ name: "search" });
    },
  },
};
</script>

<style>
nav {
  padding: 0;
  box-shadow: 0px 1px 0px #dddddd;
}

.search-box {
  background: #f8f9fa;
  border: none;
}

.search-box::placeholder {
  color: #bdbdbd;
}

.nav-btn {
  width: 100px;
  height: 100%;
  min-height: 75px;
  line-height: 0.85em;
  font-size: 0.85em;
  cursor: pointer;
  border-bottom: 4px solid transparent;
}
.nav-btn.selected {
  border-bottom: 4px solid var(--isim-primary);
}

.nav-container {
  display: flex;
  width: 100%;
  /* main-content width - padding */
  max-width: 1410px;
  position: relative;
  align-items: center;
  flex-flow: row nowrap;
  justify-content: space-between;
}

.nav-container-left {
  width: 35%;
  display: flex;
}
</style>
